import { ActionType } from '@editor/src/js/constants/common-action-type';
import { IMenuEventParams } from '@src/slide/application/service/menu-manager/menu-event/menu-event.interface';
import { IConnectorModel } from '@src/slide/domain/ui-model/element-modeles/Interface/connector-model.interface';

/**
 * 事件列表（主要逻辑从model文件迁移而来）
 */
const menuEventMap = {
    // 连接线没有填充属性，操作此属性的话执行空操作，截断后续匹配
    [ActionType.FILLCOLOR]: () => {},
};

/**
 * 事件响应匹配
 * 返回boolean值，表示此事件是否已在model独有事件匹配上，匹配上返回TRUE，结束匹配，未匹配上返回FALSE，外层继续匹配通用事件
 * @param model 当前uiModel
 * @param menuEventParams 菜单传参
 */
export function handleMenuEvent(model: IConnectorModel, menuEventParams: IMenuEventParams): boolean {
    const { actionType } = menuEventParams;
    if (menuEventMap[actionType]) {
        // 精准查找事件
        menuEventMap[actionType]();
        return true;
    }
    // 在model独有的事件中没有匹配到，返回false，外层继续匹配通用事件
    return false;
}
